module.exports = __webpack_public_path__ + "img/wind-hazard@2x.818f6b1c.png";